module.exports = __webpack_public_path__ + "static/img/brees-2005-slide-3.8c43603.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2005-slide-3.jpg
// module id = DLE2
// module chunks = 1